(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["elvar-preorder-countdown"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('elvar-preorder-countdown')) {
    customElements.define('elvar-preorder-countdown', class extends HTMLElement {
      connectedCallback() {
        this.startTime = Number(this.dataset.start) * 1000;
        this.endTime = Number(this.dataset.end) * 1000;
        this.heading = this.querySelector('[data-countdown-heading]');
        this.digits = this.querySelector('[role="timer"]');
        this.units = ['days', 'hours', 'minutes', 'seconds'].map(unit => this.querySelector('[data-unit="' + unit + '"]'));
        if (!Number.isFinite(this.startTime) || !Number.isFinite(this.endTime) || !this.heading || !this.digits || this.units.some(unit => !unit)) return;
        this.update();
        if (Date.now() < this.endTime) this.interval = window.setInterval(() => this.update(), 1000);
      }
      disconnectedCallback() { window.clearInterval(this.interval); }
      update() {
        const now = Date.now();
        const state = now < this.startTime ? 'upcoming' : now < this.endTime ? 'open' : 'closed';
        if (this.dataset.state !== state) {
          this.dataset.state = state;
          this.heading.textContent = this.dataset[state];
        }
        this.digits.hidden = state === 'closed';
        const target = state === 'upcoming' ? this.startTime : this.endTime;
        const total = Math.max(0, Math.ceil((target - now) / 1000));
        const values = [Math.floor(total / 86400), Math.floor(total % 86400 / 3600), Math.floor(total % 3600 / 60), total % 60];
        this.units.forEach((unit, index) => {
          const value = String(values[index]).padStart(2, '0');
          if (unit.textContent !== value) unit.textContent = value;
        });
        if (state === 'closed') window.clearInterval(this.interval);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
